import React from "react";
import RealMap from "../../Maps/RealMap";

export default function MapPanel({ tasks, agents }) {
  return (
    <div className="flex-1 bg-gradient-to-br from-yellow-100 to-red-100 z-0">
      <RealMap Task={tasks} drivers={agents} />
    </div>
  );
}
